import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import BoldIcon from "@redotech/redo-icons/bold-01.svg";
import ItalicIcon from "@redotech/redo-icons/italic-01_filled.svg";
import StrikethroughIcon from "@redotech/redo-icons/strikethrough-01_filled.svg";
import UnderlineIcon from "@redotech/redo-icons/underline-01_filled.svg";
import ZapIcon from "@redotech/redo-icons/zap.svg";
import { AlignToolbarButton } from "@redotech/redo-web/components/plate-ui/align-toolbar-button";
import { ClearFormattingToolbarButton } from "@redotech/redo-web/components/plate-ui/clear-formatting-toolbar-button";
import { ColorToolbarButton } from "@redotech/redo-web/components/plate-ui/color-toolbar-button";
import { EmojiToolbarButton } from "@redotech/redo-web/components/plate-ui/emoji-toolbar-button";
import { FontFamilyToolbarButton } from "@redotech/redo-web/components/plate-ui/font-family-toolbar-button";
import { FontSizeToolbarButton } from "@redotech/redo-web/components/plate-ui/font-size-toolbar-button";
import { LinkToolbarButton } from "@redotech/redo-web/components/plate-ui/link-toolbar-button";
import {
  BulletedListToolbarButton,
  NumberedListToolbarButton,
  TodoListToolbarButton,
} from "@redotech/redo-web/components/plate-ui/list-toolbar-button";
import { MarkToolbarButton } from "@redotech/redo-web/components/plate-ui/mark-toolbar-button";
import {
  FileToolbarButton,
  ImageToolbarButton,
} from "@redotech/redo-web/components/plate-ui/media-toolbar-buttons";
import {
  Toolbar,
  ToolbarButton,
  ToolbarGroup,
} from "@redotech/redo-web/components/plate-ui/toolbar";
import { cn } from "@redotech/redo-web/tailwind-utils";
import { KEYS } from "platejs";
import { memo } from "react";

function OrangeAiStarIcon() {
  return <AiStarIcon style={{ color: "var(--redo-colors-orange-dark-500)" }} />;
}

export interface EmailToolbarProps {
  className?: string;
  isGeneratingAiResponse?: boolean;
  onFileSelect?: (files: File[]) => void;
  onGenerateAiResponse?: () => void;
  onImageSelect?: (file: File) => void;
}

export const EmailToolbar = memo(function EmailToolbar({
  className,
  isGeneratingAiResponse,
  onFileSelect,
  onGenerateAiResponse,
  onImageSelect,
}: EmailToolbarProps) {
  return (
    <Toolbar
      className={cn(
        "flex items-center gap-1 overflow-x-auto border-border px-1 py-1",
        className,
      )}
    >
      <ToolbarGroup>
        <ToolbarButton
          disabled={isGeneratingAiResponse}
          Icon={OrangeAiStarIcon}
          onClick={onGenerateAiResponse}
          tooltip="AI assist"
        />
        <ToolbarButton Icon={ZapIcon} tooltip="Macros" />
      </ToolbarGroup>

      <FontFamilyToolbarButton />
      <FontSizeToolbarButton />

      <ToolbarGroup>
        <MarkToolbarButton
          Icon={BoldIcon}
          nodeType={KEYS.bold}
          tooltip="Bold (⌘+B)"
        />
        <MarkToolbarButton
          Icon={ItalicIcon}
          nodeType={KEYS.italic}
          tooltip="Italic (⌘+I)"
        />
        <MarkToolbarButton
          Icon={UnderlineIcon}
          nodeType={KEYS.underline}
          tooltip="Underline (⌘+U)"
        />
        <MarkToolbarButton
          Icon={StrikethroughIcon}
          nodeType={KEYS.strikethrough}
          tooltip="Strikethrough"
        />
      </ToolbarGroup>

      <ColorToolbarButton />
      <AlignToolbarButton />

      <NumberedListToolbarButton />
      <BulletedListToolbarButton />
      <TodoListToolbarButton />
      <LinkToolbarButton />
      <EmojiToolbarButton />
      <ImageToolbarButton onImageSelect={onImageSelect} />
      <FileToolbarButton onFileSelect={onFileSelect} />

      <ClearFormattingToolbarButton />
    </Toolbar>
  );
});
